define("ROOM4.CCAProductGallery.CCAProductGallery.Details.View", [
  "PageType.Base.View",
  "room4_ccaproductgallery_ccaproductgallery_details.tpl",
  "ROOM4.CCAProductGallery.CCAProductGallery.Model",
  "ROOM4.CCAProductGallery.CCAProductGallery.SchemaHelper",
  "ROOM4.CCAProductGallery.CCAProductGallery.DescriptionHelper",
  "ROOM4.CCAProductGallery.CCAProductGallery.VehicleFilter.Model",
  "ROOM4.CCAProductGallery.CCAProductGallery.DetailsGallery.View",
  "ROOM4.CCAProductGallery.CCAProductGallery.AccessoryDescriptions.View",
  "ROOM4.CCAProductGallery.CCAProductGallery.PackageItems.View",
  "Backbone",
  "Utils",
  "Utilities.ResizeImage",
  "jQuery",
], function (
  PageTypeBaseView,
  room4_ccaproductgallery_ccaproductgallery_details_tpl,
  CCAProductGalleryModel,
  SchemaHelper,
  DescriptionHelper,
  VehicleFilterModel,
  DetailsGalleryView,
  AccessoryDescriptionsView,
  PackageItemsView,
  Backbone,
  Utils,
  resizeImage,
  jQuery
) {
  "use strict";

  function getSlug(options) {
    var routerArguments = (options && options.routerArguments) || [];
    var routeValue =
      routerArguments.length >= 4 ? routerArguments[3] : "";
    var fragment =
      Backbone.history && Backbone.history.fragment
        ? Backbone.history.fragment
        : "";
    var pathParts = fragment.split("?")[0].replace(/^\/+/, "").split("/");
    var fragmentValue =
      pathParts[0] === "gallery" && pathParts.length >= 5
        ? pathParts[4]
        : "";
    var slug = routeValue || fragmentValue;

    try {
      return decodeURIComponent(slug);
    } catch (error) {
      return slug;
    }
  }

  function getVehicleFiltersFromModel(model) {
    return {
      year: model.get("year") || "",
      make: model.get("make") || "",
      model: model.get("model") || "",
    };
  }

  function trimValue(value) {
    return value === null || value === undefined ? "" : String(value).trim();
  }

  function getDetailImageSchemaOptions(image, publicationDate) {
    return {
      contentUrl: resizeImage(image && image.url, "fullscreen"),
      useIdForUrl: true,
      publicationDate: publicationDate,
    };
  }

  function getGalleryBreadcrumbPages(
    vehicleFilterModel,
    selectedFilters,
    detailTitle,
    detailPath
  ) {
    var pages = [
      {
        text: Utils.translate("Gallery"),
        href: "/gallery",
      },
    ];
    var make = trimValue(selectedFilters && selectedFilters.make);
    var model = trimValue(selectedFilters && selectedFilters.model);
    var year = trimValue(selectedFilters && selectedFilters.year);
    var makePath;
    var modelPath;
    var yearPath;

    if (!make || (year && !model) || !vehicleFilterModel) {
      return pages;
    }

    makePath = vehicleFilterModel.getSeoPath({
      make: make,
    });

    if (makePath === "gallery") {
      return pages;
    }

    pages.push({
      text: make,
      href: "/" + makePath,
    });

    if (!model) {
      return pages;
    }

    modelPath = vehicleFilterModel.getSeoPath({
      make: make,
      model: model,
    });

    if (modelPath === "gallery") {
      return pages;
    }

    pages.push({
      text: model,
      href: "/" + modelPath,
    });

    if (!year) {
      return pages;
    }

    yearPath = vehicleFilterModel.getSeoPath({
      make: make,
      model: model,
      year: year,
    });

    if (yearPath === "gallery") {
      return pages;
    }

    pages.push({
      text: year,
      href: "/" + yearPath,
    });

    detailTitle = trimValue(detailTitle);
    detailPath = trimValue(detailPath);

    if (detailTitle && detailPath) {
      pages.push({
        text: detailTitle,
        href: "/" + detailPath,
      });
    }

    return pages;
  }

  function getPrimaryGalleryImage(images) {
    var firstImage = null;
    var heroImage = null;

    (images || []).forEach(function (image) {
      if (!image || !image.url) {
        return;
      }

      if (!firstImage) {
        firstImage = image;
      }

      if (!heroImage && image.isHero) {
        heroImage = image;
      }
    });

    return heroImage || firstImage;
  }

  function getInternalLocationPath(value) {
    var url = String(value || "").replace(/^\s+|\s+$/g, "");
    var path;

    if (!url) {
      return "";
    }

    if (/^https?:\/\//i.test(url)) {
      path = url.replace(/^https?:\/\/[^/?#]+/i, "");
    } else if (/^\/\//.test(url)) {
      path = url.replace(/^\/\/[^/?#]+/, "");
    } else if (url.charAt(0) === "/") {
      path = url;
    } else {
      return "";
    }

    if (!path) {
      return "/";
    }

    if (path.charAt(0) === "?" || path.charAt(0) === "#") {
      return "/" + path;
    }

    return path.charAt(0) === "/" ? path : "";
  }

  function getMetaTagHtml(attributes) {
    return jQuery("<meta />", attributes).prop("outerHTML") || "";
  }

  function getGallerySocialMetaTags(title, description, pageUrl, images) {
    var metaTags = [];
    var primaryImage = getPrimaryGalleryImage(images);
    var primaryImageUrl = primaryImage
      ? SchemaHelper.getAbsoluteUrl(primaryImage.url)
      : "";
    var imageAlt =
      (primaryImage && (primaryImage.alt || primaryImage.caption)) ||
      title ||
      description ||
      "";

    metaTags.push(
      getMetaTagHtml({ property: "og:title", content: title }),
      getMetaTagHtml({ property: "og:type", content: "article" }),
      getMetaTagHtml({ property: "og:url", content: pageUrl }),
      getMetaTagHtml({
        property: "og:site_name",
        content: SchemaHelper.getOrganizationSchemaContext().name,
      }),
      getMetaTagHtml({ property: "og:description", content: description }),
      getMetaTagHtml({ name: "twitter:card", content: "summary_large_image" }),
      getMetaTagHtml({ name: "twitter:title", content: title }),
      getMetaTagHtml({ name: "twitter:description", content: description })
    );

    if (primaryImageUrl) {
      metaTags.push(
        getMetaTagHtml({ property: "og:image", content: primaryImageUrl }),
        getMetaTagHtml({
          property: "og:image:secure_url",
          content: primaryImageUrl,
        }),
        getMetaTagHtml({ property: "og:image:alt", content: imageAlt }),
        getMetaTagHtml({ name: "twitter:image", content: primaryImageUrl }),
        getMetaTagHtml({ name: "twitter:image:alt", content: imageAlt })
      );
    }

    return metaTags.join("");
  }

  return PageTypeBaseView.PageTypeBaseView.extend({
    template: room4_ccaproductgallery_ccaproductgallery_details_tpl,

    attributes: {
      id: "CCAProductGalleryDetails",
      class: "CCAProductGalleryDetails",
    },

    initialize: function initialize(options) {
      this.options = options || this.options || {};

      this.slug = getSlug(this.options);
      this.model = new CCAProductGalleryModel({
        found: false,
        slug: this.slug,
      });
      this.vehicleFilterModel = new VehicleFilterModel();
      this.accessoryDescriptionBlocks = [];
      this.title = Utils.translate("Gallery Case");
      this.page_header = Utils.translate("Gallery Case");
      this.breadcrumbPages = [
        {
          text: Utils.translate("Gallery"),
          href: "/gallery",
        },
      ];
    },

    beforeShowContent: function beforeShowContent() {
      var self = this;
      var promise = this.model.fetch({
        data: {
          slug: this.slug,
        },
      });

      promise.done(function () {
        var resolvedSlug = self.model.get("slug") || self.slug;
        var breadcrumbTitle = self.model.get("breadcrumb") || "";
        var metaDescription = self.model.get("meta_description") || "";

        self.title = self.model.get("title") || "";
        self.page_header = self.model.get("h1") || "";
        self.setMetaDescription(metaDescription);

        if (self.model.get("found")) {
          self.setMetaTags(
            getGallerySocialMetaTags(
              self.title,
              metaDescription,
              self.getSchemaCanonicalUrl(),
              self.model.get("images") || []
            )
          );
        } else {
          self.setMetaTags("");
        }

        self.breadcrumbPages = getGalleryBreadcrumbPages(
          self.vehicleFilterModel,
          getVehicleFiltersFromModel(self.model),
          breadcrumbTitle,
          self.getGalleryItemPath(resolvedSlug)
        );

        self.getBreadcrumbPages = function () {
          return self.breadcrumbPages;
        };

        self.accessoryDescriptionBlocks =
          DescriptionHelper.getAccessoryDescriptionBlocks(
            self.model.get("components") || []
          );

        self.childViews = {
          "CCAProductGallery.DetailsGallery": function () {
            return new DetailsGalleryView({
              model: self.model,
              container: self.options.container,
              canonicalUrl: self.getSchemaCanonicalUrl(),
            });
          },
          "CCAProductGallery.AccessoryDescriptions": function () {
            return new AccessoryDescriptionsView({
              accessoryDescriptionBlocks: self.accessoryDescriptionBlocks,
            });
          },
          "CCAProductGallery.PackageItems": function () {
            return new PackageItemsView({
              model: self.model,
              container: self.options.container,
              canonicalUrl: self.getSchemaCanonicalUrl(),
            });
          },
        };
      });

      return promise;
    },

    getSchemaCanonicalUrl: function getSchemaCanonicalUrl() {
      var canonicalUrl = this.getCanonical && this.getCanonical();

      return canonicalUrl || SchemaHelper.getAbsoluteUrl("/" + this.getGalleryItemPath());
    },

    getGalleryItemPath: function getGalleryItemPath(slug) {
      return this.vehicleFilterModel.getGalleryItemPath(
        getVehicleFiltersFromModel(this.model),
        slug || this.model.get("slug") || this.slug
      );
    },

    getCanonical: function getCanonical() {
      return SchemaHelper.getAbsoluteUrl("/" + this.getGalleryItemPath());
    },

    getJsonLd: function getJsonLd() {
      var pageUrl = this.getSchemaCanonicalUrl();
      var title = this.model.get("h1") || "";
      var images = this.model.get("images") || [];
      var components = this.model.get("components") || [];
      var descriptionText = this.model.get("meta_description") || "";
      var imageJsonLd = [];
      var primaryImage = null;
      var products = [];
      var vehicleJsonLd;
      var galleryJsonLd;

      if (!this.model.get("found")) {
        return jQuery.Deferred().resolve({});
      }

      images.forEach(function (image, index) {
        var currentImage = SchemaHelper.getImageJsonLd(
          image,
          index,
          pageUrl,
          title,
          getDetailImageSchemaOptions(image, this.model.get("publishdate"))
        );

        if (!currentImage) {
          return;
        }

        imageJsonLd.push(currentImage);

        if (!primaryImage || image.isHero) {
          primaryImage = currentImage;
        }
      }, this);

      components.forEach(function (component, index) {
        if (!component || !SchemaHelper.isWheelOrTireComponent(component)) {
          return;
        }

        products.push(
          SchemaHelper.getProductJsonLd(
            component,
            index,
            pageUrl,
            Utils.translate("Package Item")
          )
        );
      });

      vehicleJsonLd = SchemaHelper.getVehicleJsonLd(
        this.model,
        pageUrl,
        primaryImage
      );
      galleryJsonLd = {
        "@type": "ImageGallery",
        "@id": pageUrl + "#gallery",
        url: pageUrl,
        name: title,
        headline: title,
        description: descriptionText,
        publisher: SchemaHelper.getOrganizationJsonLd(),
      };

      if (imageJsonLd.length) {
        galleryJsonLd.image = imageJsonLd;
      }

      if (primaryImage) {
        galleryJsonLd.primaryImageOfPage = {
          "@id": primaryImage["@id"],
        };
      }

      if (vehicleJsonLd) {
        galleryJsonLd.about = vehicleJsonLd;
      }

      if (products.length) {
        galleryJsonLd.hasPart = products;
      }

      return jQuery.Deferred().resolve(galleryJsonLd);
    },

    getContext: function getContext() {
      var components = this.model.get("components") || [];
      var images = this.model.get("images") || [];
      var componentInfoBlocks = [];
      var accessoryDescriptionBlocks = this.accessoryDescriptionBlocks;
      var schemaPageUrl = this.getSchemaCanonicalUrl();
      var schemaTitle = this.model.get("h1") || "";
      var schemaDescription = this.model.get("meta_description") || "";
      var organizationSchema = SchemaHelper.getOrganizationSchemaContext();
      var primaryImageSchema = null;
      var schemaItemRefs = [];
      var setupLocationUrl = getInternalLocationPath(
        this.model.get("location_web_page")
      );
      var vehicleSchema;
      var fitmentInfoRows = [
        {
          label: Utils.translate("Rubbing:"),
          value: this.model.get("fitment_rubbing") || "",
        },
        {
          label: Utils.translate("Trimming:"),
          value: this.model.get("fitment_trimming") || "",
        },
        {
          label: Utils.translate("Lift:"),
          value: this.model.get("fitment_lift") || "",
        },
      ];
      var hasFitmentInformation = !!(
        this.model.get("fitment_rubbing") ||
        this.model.get("fitment_trimming") ||
        this.model.get("fitment_lift")
      );

      images.forEach(function (image, index) {
        var currentImageSchema = SchemaHelper.getImageSchemaContext(
          image,
          index,
          schemaPageUrl,
          schemaTitle,
          getDetailImageSchemaOptions(image, this.model.get("publishdate"))
        );

        if (!currentImageSchema) {
          return;
        }

        schemaItemRefs.push(currentImageSchema.domId);

        if (!primaryImageSchema || image.isHero) {
          primaryImageSchema = currentImageSchema;
        }
      }, this);

      vehicleSchema = SchemaHelper.getVehicleSchemaContext(
        this.model,
        schemaPageUrl,
        primaryImageSchema
      );

      components.forEach(function (component) {
        if (
          !component.storedescription ||
          !SchemaHelper.isWheelOrTireComponent(component)
        ) {
          return;
        }

        componentInfoBlocks.push({
          title: DescriptionHelper.getComponentInfoTitle(component),
          itemname: component.itemname || "",
          brand: component.brand || "",
          classfullname: component.classfullname || "",
          storedescription: component.storedescription,
        });
      });

      components.forEach(function (component, index) {
        var productSchema = SchemaHelper.getProductSchemaContext(
          component,
          index,
          schemaPageUrl,
          Utils.translate("Package Item")
        );

        if (productSchema) {
          schemaItemRefs.push(productSchema.domId);
        }
      });

      return {
        hasCase: !!this.model.get("found"),
        title: this.model.get("h1") || "",
        pageTitle: this.model.get("title") || "",
        breadcrumb: this.model.get("breadcrumb") || "",
        slug: this.model.get("slug") || this.slug,
        description: this.model.get("description") || "",
        descriptionText: this.model.get("description_text") || "",
        metaDescription: this.model.get("meta_description") || "",
        vehicle: this.model.get("vehicle") || "",
        setupLocation: this.model.get("location") || "",
        setupLocationUrl: setupLocationUrl,
        hasSetupLocationUrl: !!setupLocationUrl,
        year: this.model.get("year") || "",
        make: this.model.get("make") || "",
        model: this.model.get("model") || "",
        components: components,
        hasComponents: !!components.length,
        componentInfoBlocks: componentInfoBlocks,
        hasComponentInfoBlocks: !!componentInfoBlocks.length,
        accessoryDescriptionBlocks: accessoryDescriptionBlocks,
        hasAccessoryDescriptionBlocks: !!accessoryDescriptionBlocks.length,
        fitmentInfoRows: fitmentInfoRows,
        hasFitmentInformation: hasFitmentInformation,
        hasSpecificationInformation:
          !!componentInfoBlocks.length || hasFitmentInformation,
        hasDescriptionText: !!this.model.get("description_text"),
        hasDetailsInfo:
          !!this.model.get("description_text") ||
          !!componentInfoBlocks.length ||
          !!accessoryDescriptionBlocks.length ||
          hasFitmentInformation,
        backUrl: "/gallery",
        canonicalUrl: schemaPageUrl,
        schemaGalleryId: schemaPageUrl + "#gallery",
        schemaItemRefs: schemaItemRefs.join(" "),
        hasSchemaItemRefs: !!schemaItemRefs.length,
        schemaDescription: schemaDescription,
        schemaPublisherId: organizationSchema.id,
        schemaPublisherName: organizationSchema.name,
        schemaPublisherUrl: organizationSchema.url,
        schemaPublisherLogoUrl: organizationSchema.logoUrl,
        schemaPublisherTelephone: organizationSchema.telephone,
        schemaPublisherEmail: organizationSchema.email,
        schemaPublisherSameAs: organizationSchema.sameAs,
        hasSchemaPublisherUrl: organizationSchema.hasUrl,
        hasSchemaPublisherLogo: organizationSchema.hasLogo,
        hasSchemaPublisherTelephone: organizationSchema.hasTelephone,
        hasSchemaPublisherEmail: organizationSchema.hasEmail,
        hasSchemaPublisherSameAs: organizationSchema.hasSameAs,
        schemaPrimaryImageId: primaryImageSchema ? primaryImageSchema.id : "",
        hasSchemaPrimaryImage: !!primaryImageSchema,
        schemaVehicleId: vehicleSchema ? vehicleSchema.id : "",
        schemaVehicleName: vehicleSchema ? vehicleSchema.name : "",
        schemaVehicleBrand: vehicleSchema ? vehicleSchema.brand : "",
        schemaVehicleProductionDate: vehicleSchema
          ? vehicleSchema.productionDate
          : "",
        schemaVehicleModel: vehicleSchema ? vehicleSchema.model : "",
        schemaVehicleImageId: vehicleSchema ? vehicleSchema.imageId : "",
        hasVehicleSchema: !!vehicleSchema,
        hasSchemaVehicleBrand: !!(vehicleSchema && vehicleSchema.hasBrand),
        hasSchemaVehicleProductionDate: !!(
          vehicleSchema && vehicleSchema.hasProductionDate
        ),
        hasSchemaVehicleModel: !!(vehicleSchema && vehicleSchema.hasModel),
        hasSchemaVehicleImage: !!(vehicleSchema && vehicleSchema.hasImage),
      };
    },
  });
});
